import { VERSION_UPDATE } from "../constants/action-types";

export const updateVersion = (version) => dispatch => {
  dispatch({
    type: VERSION_UPDATE,
    payload: version
  });
};